/* ============================================================
   assets/bh-cod-form.js
   No dependencies. No jQuery. ~5 KB.

   Layer 1 (no JS)  : native form POST → /cart/add → /cart
   Layer 2 (this)   : inline validation, live total, lead capture
   Layer 3 (worker) : POST to the Draft Order worker, no checkout

   Layer 3 no longer degrades to Shopify's checkout. It used to, and the
   rescue was worse than the failure: this shop is paid at the door, so a
   customer who filled in a cash-on-delivery form and pressed ORDER landed
   on a card form, in English, with their name and address carried over as
   line-item properties — and no order created. A failed send now says so
   on this page and leaves the phone number in reach.

   This is the only JavaScript file the theme ships.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-bh-cod]');
  if (!root) return;

  var form      = root.querySelector('[data-bh-form]');
  var paneForm  = root.querySelector('[data-bh-pane="form"]');
  var paneDone  = root.querySelector('[data-bh-pane="done"]');
  var submitBtn = root.querySelector('[data-bh-submit]');
  var ctaLabel  = root.querySelector('[data-bh-cta]');
  var totalEl   = root.querySelector('[data-bh-total]');
  var variantEl = root.querySelector('[data-bh-variant]');
  var savedEl   = root.querySelector('[data-bh-saved]');
  var savedNote = root.querySelector('[data-bh-saved-note]');
  if (!form) return;

  var SOLD_OUT = !!(submitBtn && submitBtn.disabled);
  var MODE     = root.dataset.mode || 'checkout';
  var ENDPOINT = root.dataset.endpoint || '';
  var LEAD     = root.dataset.leadEndpoint || '';
  var PRODUCT  = root.dataset.productTitle || document.title;

  var STORE_KEY = 'bh_cod_draft';
  var sending = false;

  /* ---------- money -------------------------------------- */
  /* The section renders one sample amount through Shopify's own money
     filter; whatever sits before the first digit and after the last one is
     the shop's prefix and suffix. Derived, not parsed — the money_format
     string itself is full of edge cases, and getting it wrong writes the
     raw placeholder onto the price. */
  var MONEY_PRE = '';
  var MONEY_SUF = ' KM';
  (function () {
    var sample = root.dataset.moneySample || '';
    var first = sample.search(/\d/);
    if (first < 0) return;
    var last = sample.length - 1;
    while (last >= 0 && !/\d/.test(sample.charAt(last))) last--;
    MONEY_PRE = sample.slice(0, first);
    MONEY_SUF = sample.slice(last + 1);
  })();

  /* Shopify money is in minor units (fening). 4900 → "KM 49" */
  function money(cents) {
    var n = cents / 100;
    var s = (n % 1 === 0) ? String(n) : n.toFixed(2).replace('.', ',');
    return MONEY_PRE + s + MONEY_SUF;
  }

  /* ---------- validation --------------------------------- */
  var RULES = {
    name:    function (v) { return v.trim().length >= 3; },
    /* Eight digits after the country code, however the number was written.
       The old rule counted raw digits between 8 and 12, which accepted
       06487019 — one short of a real mobile — and let it through to
       Shopify, which refused the whole order and told the customer to
       check her internet. Same normalisation as the worker: shed 00, 387
       and a leading zero, then count. */
    phone:   function (v) {
      var d = v.replace(/\D/g, '').replace(/^00/, '').replace(/^387/, '').replace(/^0/, '');
      /* A floor, not a specification — mirroring the worker. Every time
         this pretended to know the exact shape of a BiH number it refused
         a real customer instead; one of them tried fifteen times. Only an
         obviously-too-short number is stopped here, where it can still be
         corrected. */
      return d.length >= 8 && d.length <= 12;
    },
    address: function (v) { return v.trim().length >= 4; },
    city:    function (v) { return v.trim().length >= 2; },
    /* The two optional ones: empty is valid, so neither can ever block an
       order. Only a non-empty malformed value errors. The email check is
       deliberately loose — the strict RFC pattern rejects real addresses,
       and the cost of a typo is a bounced mail, not a lost delivery. A
       blank zip is filled in from the city by the worker. */
    zip:     function (v) { var s = v.trim(); return s === '' || /^[0-9]{5}$/.test(s); },
    email:   function (v) { var s = v.trim(); return s === '' || /^[^\s@]+@[^\s@.]+\.[^\s@]{2,}$/.test(s); }
  };

  /* Too long to be a BiH number. RULES.phone stays a floor on purpose (see
     above), so this never refuses anyone: it asks once. A real order came
     in as 30763349429 — 063 349 429 with a slipped finger — and Shopify
     refused the number after the fact, when the customer was gone. Eight
     digits is a landline or most mobiles, nine is 060/061; past nine is a
     typo almost every time. The first press says so at the field; pressing
     ORDER again with the same number sends it as typed. */
  function phoneTooLong(v) {
    return v.replace(/\D/g, '').replace(/^00/, '').replace(/^387/, '').replace(/^0/, '').length > 9;
  }
  var phoneWarned = null;
  var phoneErrEl = document.getElementById('bh-err-phone');
  var PHONE_ERR = phoneErrEl ? phoneErrEl.textContent : '';

  function fieldOf(key) { return root.querySelector('[data-bh-field="' + key + '"]'); }
  function inputOf(key) { var f = fieldOf(key); return f && f.querySelector('.bh-input'); }

  /* The field's own label, so the summary names fields the way the page
     does — minus the "(opcionalno)" suffix, which would read as noise in
     a list of problems. Read from the DOM so it stays translated. */
  function labelOf(key) {
    var f = fieldOf(key);
    var l = f && f.querySelector('label');
    if (!l) return key;
    var opt = l.querySelector('.bh-field__opt');
    var text = l.textContent;
    if (opt) text = text.replace(opt.textContent, '');
    return text.replace(/\s+/g, ' ').trim();
  }

  function check(key, showError) {
    var input = inputOf(key);
    if (!input) return true;
    var ok = RULES[key](input.value);
    if (showError && key === 'phone' && phoneErrEl) phoneErrEl.textContent = PHONE_ERR;
    if (showError) {
      fieldOf(key).setAttribute('data-invalid', ok ? 'false' : 'true');
      /* aria-invalid is what a screen reader announces on the field
         itself; aria-describedby (set in the section) points at the
         message under it. */
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    }
    return ok;
  }

  /* Returns every bad field, in the order they appear on the page, so the
     summary can name them and focus can go to the first one. */
  function validateAll(showErrors) {
    return Object.keys(RULES).filter(function (key) {
      return !check(key, showErrors);
    });
  }

  var formErr = root.querySelector('[data-bh-formerr]');

  function showFormError(bad) {
    if (!formErr) return;
    if (!bad.length) {
      formErr.hidden = true;
      formErr.textContent = '';
      return;
    }
    var names = bad.map(labelOf).join(', ');
    formErr.textContent = (root.dataset.errFormLabel || 'Narudžba nije poslana. Provjerite:') + ' ' + names;
    formErr.hidden = false;
  }

  /* Errors clear as soon as the field becomes valid — never nag */
  Object.keys(RULES).forEach(function (key) {
    var input = inputOf(key);
    if (!input) return;
    input.addEventListener('input', function () {
      if (fieldOf(key).getAttribute('data-invalid') === 'true') check(key, true);
      /* Once the summary is up, keep it honest: the list shrinks as fields
         get fixed and disappears when nothing is left. Only re-validates
         everything after a failed submit, so it never nags first-time. */
      if (formErr && !formErr.hidden) showFormError(validateAll(true));
      persist();
    });
    input.addEventListener('blur', function () {
      /* Leave the too-long warning up until the number is edited. Clearing
         it on blur shrank the field the moment the customer tapped ORDER a
         second time, the button jumped up a line under their finger and the
         tap landed on nothing. */
      var held = key === 'phone' && phoneWarned !== null && input.value.trim() === phoneWarned;
      if (input.value.trim() !== '' && !held) check(key, true);
      if (key === 'phone') onPhoneBlur(input.value);
    });
  });

  /* Enter moves on; it does not send. A press of Enter (or the iPhone's
     "next") after the name used to submit the whole form, and every field
     still empty turned red under "Narudžba nije poslana" — on the first
     field, before the customer had done anything wrong. Enter now goes to
     the next empty field, and only sends when there is none left. */
  form.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' || ev.isComposing) return;
    var t = ev.target;
    if (!t || !t.classList || !t.classList.contains('bh-input')) return;
    var keys = Object.keys(RULES);
    var at = -1;
    keys.forEach(function (k, i) { if (inputOf(k) === t) at = i; });
    if (at < 0) return;
    for (var i = at + 1; i < keys.length; i++) {
      var next = inputOf(keys[i]);
      if (next && !next.value.trim()) { ev.preventDefault(); next.focus(); return; }
    }
    /* nothing empty after this one: if a required field earlier is still
       empty, go back to it rather than sending a form that will be refused */
    var bad = validateAll(false);
    if (bad.length) { ev.preventDefault(); inputOf(bad[0]).focus(); }
  });

  /* ---------- draft persistence (survives a reload) ------- */
  function persist() {
    try {
      var data = {};
      Object.keys(RULES).forEach(function (k) { var i = inputOf(k); if (i) data[k] = i.value; });
      localStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch (e) { /* private mode — ignore */ }
  }

  function restore() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      Object.keys(RULES).forEach(function (k) {
        var i = inputOf(k);
        if (i && !i.value && data[k]) i.value = data[k];
      });
    } catch (e) { /* ignore */ }
  }
  restore();

  /* ---------- lead capture on phone blur ------------------ */
  var leadSent = false;
  function onPhoneBlur(value) {
    var ok = RULES.phone(value);
    if (savedEl) savedEl.setAttribute('data-on', ok ? 'true' : 'false');
    /* The tick is aria-hidden, so the sentence is what a screen reader gets.
       Writing it into a role=status region is what makes it announce. */
    if (savedNote) savedNote.textContent = ok ? (savedNote.dataset.text || '') : '';
    if (!ok || leadSent || !LEAD) return;
    leadSent = true;
    var body = JSON.stringify({
      phone: value,
      product: PRODUCT,
      url: location.href,
      at: new Date().toISOString()
    });
    /* sendBeacon survives the customer closing the tab mid-form.
       text/plain, not application/json: application/json is not a
       CORS-safelisted content type, so it forces a preflight, and a
       preflight cannot complete while the page is unloading — which
       is exactly the moment this call has to survive. The body is
       still JSON; the worker parses either. */
    if (navigator.sendBeacon) {
      navigator.sendBeacon(LEAD, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
    } else {
      fetch(LEAD, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body, keepalive: true })
        .catch(function () { leadSent = false; });
    }
  }

  /* ---------- sold out: "javite mi kad stigne" ------------ */
  /* Goes down the same lead path as the phone captured on blur, marked so
     whoever reads the leads knows what this person is waiting for. */
  (function () {
    var box = root.querySelector('[data-bh-notify]');
    if (!box) return;
    var inp = box.querySelector('[data-bh-notify-phone]');
    var btn = box.querySelector('[data-bh-notify-send]');
    var msg = box.querySelector('[data-bh-notify-msg]');
    var url = LEAD || (ENDPOINT ? ENDPOINT.replace(/\/+$/, '') + '/lead' : '');
    btn.addEventListener('click', function () {
      if (!RULES.phone(inp.value)) {
        msg.textContent = msg.dataset.bad || '';
        msg.setAttribute('data-err', '');
        inp.focus();
        return;
      }
      var body = JSON.stringify({
        phone: inp.value.trim(),
        product: PRODUCT + ' — RASPRODANO, javiti kad stigne',
        url: location.href,
        at: new Date().toISOString()
      });
      if (url) {
        try {
          fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body, keepalive: true })
            .catch(function () {});
        } catch (e) { /* the thanks is still true for the call they will get */ }
      }
      btn.disabled = true;
      inp.disabled = true;
      msg.removeAttribute('data-err');
      msg.textContent = msg.dataset.ok || '';
    });
  })();

  /* ---------- pack picker --------------------------------- */
  var currentPrice = parseInt(root.dataset.price, 10) || 0;
  var currentPack  = '';
  var packs = root.querySelectorAll('[data-bh-pack]');

  function selectPack(btn) {
    Array.prototype.forEach.call(packs, function (p) {
      p.setAttribute('aria-checked', p === btn ? 'true' : 'false');
    });
    if (variantEl) variantEl.value = btn.dataset.variantId;
    currentPrice = parseInt(btn.dataset.price, 10);
    currentPack  = btn.dataset.packName || '';
    /* "Boja: Crna" above the swatches — the name is the only place the
       choice is spelled out, so it follows the tap. */
    var now = root.querySelector('[data-bh-pack-current]');
    if (now) now.textContent = currentPack;
    paintPrice();
    showShot(btn.dataset.media);
  }

  /* The gallery lives in its own section and switches on hidden radios, so
     it is reached from `document`, not `root`. Liquid put the position of
     each variant's image on the button; a pack whose image is not in the
     rendered eight has no attribute and the photo is left alone — better a
     stale-but-correct picture than one that jumps to image 1 on every tap.

     Clicking the label would work too, but `checked` plus an input event
     is what the radio itself would do, and it does not depend on a label
     existing for that index. */
  function showShot(n) {
    if (!n) return;
    var radio = document.getElementById('bh-gal-' + n);
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Delivery is charged once per order and is the same for every pack. The
     worker bills the identical figure, so the button and the Shopify order
     agree to the fening. */
  var SHIPPING = parseInt(root.dataset.shipping, 10) || 0;

  /* ---------- how many ------------------------------------ */
  /* The "Koliko komada?" cards, when the section drew them. Each card says
     its own price for the lot and whether it ships free; the worker reads
     the same tiers from the product and computes the order's total itself,
     so the figure here is what the page promises and the worker is what
     makes it true. Without the cards this is one piece at the unit price,
     exactly as before. */
  var qtyOpts  = root.querySelectorAll('[data-bh-qty-opt]');
  var qtyInput = form.querySelector('[data-bh-quantity]');
  var qtyCard  = null;

  function qtyNow() { return qtyCard ? parseInt(qtyCard.dataset.qty, 10) || 1 : 1; }

  /* What the goods cost. Never more than the unit price times the count —
     the same rule the worker applies — so no card can quote a "deal" dearer
     than buying them one by one. */
  function goodsCents() {
    var n = qtyNow();
    var full = currentPrice * n;
    if (n < 2) return full;
    var lot = parseInt(qtyCard.dataset.goods, 10);
    return lot > 0 && lot < full ? lot : full;
  }

  function shipCents() {
    return qtyCard && qtyCard.dataset.freeShip === 'true' ? 0 : SHIPPING;
  }

  function payableCents() { return goodsCents() + shipCents(); }

  /* "Toper — Crna · 3 kom": what the recap and the failure log call it */
  function boughtName() {
    var n = qtyNow();
    return PRODUCT + (currentPack ? ' — ' + currentPack : '')
      + (n > 1 ? ' · ' + n + ' ' + (root.dataset.pcsLabel || 'kom') : '');
  }

  function selectQty(card) {
    Array.prototype.forEach.call(qtyOpts, function (c) {
      c.setAttribute('aria-checked', c === card ? 'true' : 'false');
    });
    qtyCard = card;
    if (qtyInput) qtyInput.value = String(qtyNow());
    paintPrice();
  }

  Array.prototype.forEach.call(qtyOpts, function (c) {
    c.addEventListener('click', function () { selectQty(c); });
    if (c.getAttribute('aria-checked') === 'true') qtyCard = c;
  });
  /* arrow keys move the choice, as they do in any radio group */
  if (qtyOpts.length) {
    qtyOpts[0].parentNode.addEventListener('keydown', function (ev) {
      var k = ev.key;
      if (k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'ArrowRight' && k !== 'ArrowLeft') return;
      var list = Array.prototype.slice.call(qtyOpts);
      var i = list.indexOf(qtyCard || list[0]);
      var next = list[(i + (k === 'ArrowDown' || k === 'ArrowRight' ? 1 : list.length - 1)) % list.length];
      ev.preventDefault();
      selectQty(next);
      next.focus();
    });
  }
  if (qtyInput) qtyInput.value = String(qtyNow());

  /* The title/price block is a sibling of this form, not a descendant — one
     sticky card can only be one box, so they live outside [data-bh-cod]. */
  var heroPrice   = document.querySelector('[data-bh-hero-price]');
  var heroCompare = document.querySelector('[data-bh-hero-compare]');
  var heroSave    = document.querySelector('[data-bh-hero-save]');

  function paintPrice() {
    /* The hero shows the PRODUCT price — it is the number in the ad, and an
       ad-to-page mismatch loses more orders than it saves. The button shows
       what the courier will actually ask for. */
    var payable = money(payableCents());
    if (totalEl) totalEl.textContent = payable;

    /* the breakdown under the button has to follow the pack picker too, or
       it explains a total that is no longer the one being charged */
    var sum = function (k, text) {
      var n = root.querySelector('[data-bh-sum="' + k + '"]');
      if (n) n.textContent = text;
    };
    var n = qtyNow();
    sum('qty', n > 1 ? ' (' + n + ' ' + (root.dataset.pcsLabel || 'kom') + ')' : '');
    sum('product', money(goodsCents()));
    sum('shipping', shipCents() > 0 ? money(shipCents()) : (root.dataset.freeLabel || '0'));
    sum('total', payable);
    /* Not on a sold-out product. Liquid wrote "Trenutno nema na stanju" onto
       this button and disabled it; quoting a price over that offers a deal
       the shop cannot honour, on the one control the customer cannot press. */
    if (ctaLabel && !SOLD_OUT) ctaLabel.textContent = ctaLabel.dataset.base + ' — ' + payable;
    /* The bar shows the price of the goods, like the hero and the ad — not
       goods plus delivery struck against a compare price that never
       included delivery, which put two prices for one thing side by side
       ("KM 39,80" over "KM 59,90" under an ad that said 29,90). The total
       is said on the order button, where it is being agreed to. */
    var stickyPrice = document.querySelector('[data-bh-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = money(goodsCents());
    var stickyWas = document.querySelector('.bh-price__was--sticky');
    if (stickyWas) {
      var cur = current();
      var cmp = cur ? parseInt(cur.dataset.compare, 10) || 0 : parseInt(stickyWas.dataset.compare, 10) || 0;
      var showWas = qtyNow() < 2 && cmp > currentPrice;
      stickyWas.hidden = !showWas;
      if (showWas) stickyWas.textContent = money(cmp);
    }

    if (heroPrice) heroPrice.textContent = money(currentPrice);

    /* With no picker there is nothing to repaint — Liquid already rendered
       the one variant's compare price, and recomputing it from a pack that
       does not exist would wipe a real discount off a single-variant page. */
    if (!packs.length) return;

    /* A pack with no compare price must not keep the previous pack's struck
       figure on screen — that is a false discount. */
    var pack = current();
    var compare = pack ? parseInt(pack.dataset.compare, 10) || 0 : 0;
    var saves = compare > currentPrice;
    if (heroCompare) {
      heroCompare.textContent = saves ? money(compare) : '';
      heroCompare.hidden = !saves;
    }
    if (heroSave) {
      heroSave.textContent = saves
        ? (heroSave.dataset.base || '') + ' ' + money(compare - currentPrice)
        : '';
      heroSave.hidden = !saves;
    }
  }

  function current() {
    for (var i = 0; i < packs.length; i++) {
      if (packs[i].getAttribute('aria-checked') === 'true') return packs[i];
    }
    return null;
  }

  if (ctaLabel) ctaLabel.dataset.base = (ctaLabel.textContent.split('—')[0] || '').trim();

  if (packs.length) {
    Array.prototype.forEach.call(packs, function (p) {
      p.addEventListener('click', function () { selectPack(p); });
      if (p.getAttribute('aria-checked') === 'true') {
        currentPrice = parseInt(p.dataset.price, 10);
        currentPack  = p.dataset.packName || '';
      }
    });
  }
  paintPrice();

  /* ---------- submit -------------------------------------- */
  /* Tells the inline guard in the section that the real handler is attached,
     so it can stop holding presses. Set before the listener is added rather
     than after: between the two there is no window for a press to fall
     through, because the guard cancels every native POST either way. */
  form.setAttribute('data-bh-live', 'true');
  /* The guard cancels every native POST. If this shop is configured to use
     Shopify's checkout rather than the worker, that POST is the whole
     mechanism, so hand the guard its exemption. */
  if (MODE !== 'worker' || !ENDPOINT) form.setAttribute('data-bh-native', 'true');

  form.addEventListener('submit', function (ev) {
    var bad = validateAll(true);
    showFormError(bad);

    if (bad.length) {
      ev.preventDefault();
      var el = inputOf(bad[0]);
      /* scrollIntoView is avoided on purpose — it fights the sticky bar */
      var y = el.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo(0, y < 0 ? 0 : y);
      el.focus();
      return;
    }

    var phoneVal = inputOf('phone').value.trim();
    if (phoneTooLong(phoneVal) && phoneWarned !== phoneVal) {
      ev.preventDefault();
      phoneWarned = phoneVal;
      if (phoneErrEl) phoneErrEl.textContent = root.dataset.warnPhoneLabel || PHONE_ERR;
      fieldOf('phone').setAttribute('data-invalid', 'true');
      if (formErr) {
        formErr.textContent = root.dataset.warnPhoneFormLabel || '';
        formErr.hidden = false;
      }
      var pel = inputOf('phone');
      var py = pel.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo(0, py < 0 ? 0 : py);
      pel.focus();
      return;
    }

    /* Mode 1: let the browser POST to /cart/add?return_to=/checkout */
    if (MODE !== 'worker' || !ENDPOINT) return;

    /* Mode 2: intercept and create the order server-side */
    ev.preventDefault();
    if (sending) return;
    sending = true;
    lockButton(true);

    var payload = {
      variantId: variantEl ? variantEl.value : '',
      quantity: qtyNow(),
      name:    inputOf('name').value.trim(),
      phone:   inputOf('phone').value.trim(),
      address: inputOf('address').value.trim(),
      city:    inputOf('city').value.trim(),
      zip:     inputOf('zip') ? inputOf('zip').value.trim() : '',
      email:   inputOf('email') ? inputOf('email').value.trim() : '',
      note:    'COD — Shopify tema BiH',
      url:     location.href
    };

    /* Slow is not failed. This used to declare failure at 12s and unlock the
       button while the request was still running: the order went through a
       few seconds later, but by then the page had said "nije poslana", the
       customer had pressed again, and the shop had two orders. Now 12s only
       says, calmly, that it is still going, with the button still locked;
       failure is declared on a real error or after 35s. A success that lands
       after that still takes over the screen (startOffers does not check
       `sending`), because the order exists and the customer must see it. */
    var started = Date.now();
    var BUDGET = 35000;
    var slow = setTimeout(function () { showWaiting(true); }, 12000);
    var timeout = setTimeout(function () { showWaiting(false); failSoft(); }, BUDGET);

    /* One quiet retry, and only when the request never reached the worker.

       A fetch that rejects rather than answering is a dropped connection —
       a phone stepping between masts, a lift, a tunnel — and on this market
       most orders come from a phone. Making the customer read an error and
       press the button again loses some of them to something that would
       have worked a second later.

       Only network failures are retried. Anything the worker actually
       answered — a refusal, a rate limit, a validation error — is a
       decision, and repeating it would just place the same order twice. */
    var attempt = function (retriesLeft) {
      /* keepalive, because the tab can go away while this is in flight.
         Without it the browser cancels the request on unload, and whether
         the order survives comes down to whether Cloudflare had already
         read the whole body — a race nobody should be running for a paid
         order. With it the browser is obliged to finish the send even
         after the page is gone. The retry above cannot help there: once
         the page unloads there is no timer left to fire it. */
      return fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify(payload)
      }).catch(function (err) {
        if (!retriesLeft) throw err;
        return new Promise(function (res) {
          setTimeout(function () { res(attempt(retriesLeft - 1)); }, 1200);
        });
      });
    };

    /* The body is read even on a failure. Every refusal used to arrive as
       the same silent throw, so "check your connection" was printed at a
       customer whose connection was fine and who had simply ordered twice
       in an hour — advice that cannot work, given to someone who cannot
       act on it. The worker names its reasons; this reads the name.

       409 "pending" is the worker saying this exact order is already being
       created by an earlier request (the retry above, or a press that beat
       the lock). It is not a refusal: wait and ask again, inside the same
       budget, and the answer will be the order that request made. */
    var send = function () {
      return attempt(1).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (r.ok) return d;
          if (r.status === 409 && d && d.error === 'pending' && Date.now() - started < BUDGET - 4000) {
            return new Promise(function (res) { setTimeout(res, 3000); }).then(send);
          }
          var e = new Error('HTTP ' + r.status);
          e.status = r.status;
          e.code = d && d.error;
          e.detail = d && d.detail;
          throw e;
        });
      });
    };

    send()
      .then(function (data) {
        clearTimeout(slow);
        clearTimeout(timeout);
        showWaiting(false);
        startOffers(data, payload);
      })
      .catch(function (err) {
        clearTimeout(slow);
        clearTimeout(timeout);
        showWaiting(false);
        failSoft(err);
      });
  });

  /* "Još šaljemo" — neutral, not red: nothing has gone wrong yet, and red
     here is what made people press again. Uses the error line's place so it
     sits where the customer is looking, with its own look. */
  function showWaiting(on) {
    if (!formErr) return;
    if (on) {
      formErr.textContent = root.dataset.stillSendingLabel
        || 'Još šaljemo narudžbu — ne zatvarajte stranicu.';
      formErr.setAttribute('data-wait', 'true');
      formErr.hidden = false;
    } else if (formErr.getAttribute('data-wait') === 'true') {
      formErr.removeAttribute('data-wait');
      formErr.textContent = '';
      formErr.hidden = true;
    }
  }

  /* Somebody pressed ORDER while this file was still on the wire. The guard
     cancelled the POST and left a flag; honour the press now rather than
     making them find the button again. */
  if (form.getAttribute('data-bh-early') === 'true') {
    form.removeAttribute('data-bh-early');
    if (submitBtn) submitBtn.removeAttribute('data-bh-waiting');
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function lockButton(on) {
    if (!submitBtn) return;
    submitBtn.disabled = on;
    submitBtn.style.opacity = on ? '.65' : '';
    if (ctaLabel) {
      ctaLabel.textContent = on
        ? (root.dataset.sendingLabel || 'ŠALJEMO…')
        : ctaLabel.dataset.base + ' — ' + money(payableCents());
    }
  }

  /* If the worker is down the customer must NOT lose the order. */
  /* This used to hand the customer to Shopify's checkout when the worker was
     slow or unreachable. It was the wrong rescue: this shop takes payment at
     the door, and Shopify's checkout asks for a card. A customer who filled
     in a COD form and pressed ORDER landed on a card form in English with
     their name and address glued on as line-item properties — no order was
     created, and the ones who did not abandon paid twice over in confusion.
     Better to stay on our own page and say plainly that it did not go
     through, with the phone number already on screen a thumb away. */
  /* Every refusal is reported, because the person it happened to is the
     most valuable name the shop will see all day: they typed their address
     and asked to buy. Until this existed they simply vanished — the page
     apologised and nobody ever knew. Fire and forget, keepalive so it
     survives the tab being closed in frustration, and wrapped so a failure
     to log a failure cannot become a second failure. */
  function reportFailure(err) {
    if (!ENDPOINT) return;
    try {
      var val = function (k) { var i = inputOf(k); return i ? i.value.trim() : ''; };
      fetch(ENDPOINT.replace(/\/+$/, '') + '/fail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          reason: err && (err.status === 429 || err.code === 'rate') ? 'rate'
                : err && err.status ? 'http-' + err.status
                : err ? 'mreza' : 'timeout',
          /* The worker says exactly what went wrong; only its short code
             was being written down, so three lost orders read "shopify"
             and the reason had to be reproduced by hand afterwards. */
          detail: err ? String(err.detail || err.code || err.message || '').slice(0, 300) : '',
          name: val('name'), phone: val('phone'), address: val('address'),
          city: val('city'), zip: val('zip'), email: val('email'),
          product: boughtName(),
          total: payableCents(),
          url: location.href
        })
      }).catch(function () {});
    } catch (e) { /* never let logging break the page */ }
  }

  function failSoft(err) {
    if (!sending) return;
    sending = false;
    lockButton(false);
    reportFailure(err);
    if (formErr) {
      var code = err && err.code;
      var rate = err && (err.status === 429 || code === 'rate');
      /* Naming the field is the whole point. Three orders were lost in one
         morning to a phone number Shopify would not accept, and every one
         of those customers was told to check their internet — advice that
         could not work, about a problem they could have fixed in seconds. */
      formErr.textContent = code === 'phone'
        ? (root.dataset.errPhoneLabel
            || 'Provjerite broj telefona — izgleda da nedostaje cifra.')
        : rate
          ? (root.dataset.errRateLabel
              || 'Već ste poslali narudžbu maloprije. Sačekajte malo ili nas nazovite.')
          : (root.dataset.errSendLabel
              || 'Narudžba nije poslana. Provjerite internet i pokušajte ponovo, ili nas nazovite.');
      formErr.hidden = false;
    }
    var focusOn = (err && err.code === 'phone') ? inputOf('phone') : (formErr || form);
    if (focusOn && err && err.code === 'phone') {
      fieldOf('phone').setAttribute('data-invalid', 'true');
      focusOn.focus();
    }
    var y = (focusOn || form).getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo(0, y < 0 ? 0 : y);
  }

  /* ---------- one-click upsell queue ----------------------- */
  /* Runs only AFTER the worker has created the order. Every offer appends a
     line to an order that already exists, so abandoning at any point — a
     decline, a dead endpoint, a closed tab — leaves precisely the order the
     customer would have had if this queue did not exist. That property is
     the whole design; nothing below is allowed to break it.

     The worker has to return `orderId` and a short-lived signed `token`
     alongside the order for any of this to run. Until it does, the offers
     stay hidden and the customer goes straight to the confirmation, exactly
     as before — which is what makes it safe to ship this half first. */
  /* document, not root: the cards live in their own section now, so the
     same list can serve the sheet on app-built pages too */
  var offers    = [].slice.call(document.querySelectorAll('[data-bh-pane="offer"]'));
  var offerIdx  = 0;
  var runTotal  = 0;
  var orderRef  = null;
  var offerBusy = false;
  /* what the customer actually said yes to, so the confirmation can name it.
     A recap showing one product and a total covering three is the moment
     somebody starts wondering what they have been charged for. */
  var accepted = [];
  var TIMER_MIN = parseInt(root.dataset.offerTimer, 10) || 0;
  var tick      = null;

  /* While an offer is up it owns the screen: the phone button, the
     guarantees and every section below the form are taken out of flow, so
     the offer is not competing with another call to action and nothing
     that follows it can creep above the fold. Undone on the confirmation. */
  function offerMode(on) {
    document.body.toggleAttribute('data-bh-offer-open', !!on);
  }

  function stopTimer() {
    if (tick) { clearInterval(tick); tick = null; }
  }

  /* One countdown per offer, restarted each time. On zero the offer declines
     itself and the queue moves on — the order was created before any of this
     and is not touched either way. */
  function startTimer(el, onExpiry) {
    stopTimer();
    var out = el.querySelector('[data-bh-offer-timer]');
    if (!out || TIMER_MIN <= 0) { if (out) out.hidden = true; return; }

    var left = TIMER_MIN * 60;
    out.hidden = false;
    var paint = function () {
      var m = Math.floor(left / 60);
      var s = left % 60;
      out.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    };
    paint();
    tick = setInterval(function () {
      left -= 1;
      if (left <= 0) { stopTimer(); out.textContent = '0:00'; return onExpiry(); }
      paint();
    }, 1000);
  }

  /* Past this line the order exists in Shopify. Everything the offer queue
     does afterwards is a bonus, and no bonus is allowed to cost the customer
     the one thing they are owed: being told the order was taken.

     This is not hypothetical. A stray closing tag once left the confirmation
     outside the element this script searches, so `paneDone` was null; the
     form hid itself, the offer machinery threw, and the customer sat looking
     at an empty card wondering whether to order again. Several did.

     So the queue runs inside a net. Anything it throws lands on the
     confirmation, and if even that cannot be drawn the form comes back with
     the order number in the error line — ugly, but it never lies about
     whether the order exists. */
  function startOffers(data, payload) {
    runTotal = data.totalCents != null ? data.totalCents : payableCents();
    orderRef = (data.orderId && data.token)
      ? { id: data.orderId, token: data.token }
      : null;

    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
    if (sticky) sticky.setAttribute('data-visible', 'false');

    try {
      /* Not just "is it null". The element is looked up when the script
         starts, so anything that replaces the card afterwards — a section
         re-render in the theme editor, an app rewriting the DOM, a bad
         merge of the markup — leaves this variable pointing at a node that
         is no longer on the page. Writing the confirmation into it then
         succeeds silently and shows the customer nothing at all, which is
         the exact failure this net exists to catch. */
      if (!paneDone || !document.contains(paneDone)) throw new Error('nema potvrde');
      paneForm.hidden = true;
      /* A refused phone goes straight to the confirmation, where the field
         to fix it is. An offer first is two to three minutes in which the
         only person who can supply a working number may close the tab. */
      if (!orderRef || !offers.length || data.phoneUnverified) return showConfirmation(data, payload);
      offerIdx = 0;
      nextOffer(data, payload);
    } catch (e) {
      lastResort(data);
    }
  }

  /* The confirmation itself is broken. Say the one true thing that is left,
     in the place the customer is already looking. */
  function lastResort(data) {
    var num = (data && (data.orderNumber || data.name)) || '';
    if (paneForm) paneForm.hidden = false;
    if (formErr) {
      formErr.textContent = (root.dataset.confirmedFallback
        || 'Narudžba je primljena. Broj narudžbe: ') + num;
      formErr.hidden = false;
      formErr.setAttribute('data-ok', 'true');
    }
    if (submitBtn) submitBtn.disabled = true;
  }

  function nextOffer(data, payload) {
    try {
      drawOffer(data, payload);
    } catch (e) {
      /* a broken offer must not swallow a good order */
      try { showConfirmation(data, payload); } catch (e2) { lastResort(data); }
    }
  }

  function drawOffer(data, payload) {
    stopTimer();
    offers.forEach(function (o) { o.hidden = true; });
    if (offerIdx >= offers.length) return showConfirmation(data, payload);

    offerMode(true);
    var el = offers[offerIdx];
    el.hidden = false;
    /* The offer has to be readable without scrolling, so put its top at the
       top of the viewport rather than nudging it into view. */
    var y = el.getBoundingClientRect().top + window.pageYOffset - 8;
    window.scrollTo(0, y < 0 ? 0 : y);

    var yes = el.querySelector('[data-bh-offer-yes]');
    var no  = el.querySelector('[data-bh-offer-no]');
    var skip = function () { offerIdx++; nextOffer(data, payload); };
    if (no)  no.onclick  = skip;
    if (yes) yes.onclick = function () { acceptOffer(el, data, payload); };
    startTimer(el, skip);
  }

  function acceptOffer(el, data, payload) {
    if (offerBusy) return;
    offerBusy = true;
    var yes = el.querySelector('[data-bh-offer-yes]');
    if (yes) { yes.disabled = true; yes.style.opacity = '.65'; }

    stopTimer();
    var price = parseInt(el.dataset.price, 10) || 0;
    var title = el.querySelector('.bh-offer__h');
    if (title) accepted.push(title.textContent.trim());
    /* Whatever happens next, move on — an upsell must never strand someone
       on a spinner after their order is already placed. */
    var done = function (added) {
      offerBusy = false;
      if (yes) { yes.disabled = false; yes.style.opacity = ''; }
      if (added != null) runTotal = added;
      offerIdx++;
      nextOffer(data, payload);
    };
    /* Same reasoning as the catch below: after nine seconds we do not know
       whether the line landed, and guessing that it did prints a total the
       courier may not be collecting. Move on without it. The confirmation
       call the shop makes on every order is where a late arrival gets
       sorted out. */
    var give = setTimeout(function () {
      if (title) {
        var i = accepted.lastIndexOf(title.textContent.trim());
        if (i > -1) accepted.splice(i, 1);
      }
      done(null);
    }, 9000);

    fetch(ENDPOINT.replace(/\/+$/, '') + '/upsell', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        orderId:     orderRef.id,
        token:       orderRef.token,
        variantId:   el.dataset.variant,
        discountPct: parseInt(el.dataset.discount, 10) || 0,
        quantity:    1
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (res) {
        clearTimeout(give);
        done(res && res.totalCents != null ? res.totalCents : runTotal + price);
      })
      .catch(function () {
        /* The request failed, so the line is very probably not on the order.
           Take the offer back out of the recap and off the total rather than
           printing a figure the courier will not be collecting: this is cash
           on delivery, and a receipt that promises an item the driver is not
           carrying is worse than one that never mentioned it. Shopify is the
           record; the page follows it, not the other way round. */
        clearTimeout(give);
        if (title) {
          var i = accepted.lastIndexOf(title.textContent.trim());
          if (i > -1) accepted.splice(i, 1);
        }
        done(null);
      });
  }


  /* ---------- add more, into the same order ---------------- */
  /* The catalogue comes from Shopify on the shop's own domain, not through
     the worker. The worker holds an Admin API token, and putting the
     product list behind it would guard a public catalogue with a
     credential and spend a request on something Shopify already caches.

     Fetched once, and only after an order exists — rendering these rows
     into every product page would hand the whole catalogue to every
     visitor, and most visitors never order. */
  var moreWrap = root.querySelector('[data-bh-more]');
  var moreGrid = root.querySelector('[data-bh-more-grid]');
  var moreNote = root.querySelector('[data-bh-more-note]');
  var moreBusy = false;

  function moreSay(text) {
    if (!moreNote) return;
    moreNote.textContent = text || '';
    moreNote.hidden = !text;
  }

  function openMore(data, payload) {
    if (!moreWrap || !moreGrid || !orderRef) return;
    var url = root.dataset.moreUrl;
    if (!url) return;

    /* No Accept header. Asking Shopify for application/json on a storefront
       URL makes it answer 404 with an empty body — it reads the header as a
       call to an API that does not exist, rather than a request for this
       template. The template returns JSON either way; the header was mine,
       and it was the whole bug. */
    /* Shopify throttles, and a throttled storefront answers 429 with an HTML
       error page — which parses as nothing and leaves an empty list where
       the catalogue should be. One retry, two seconds later, because the
       thing being lost here is the only place a second item can be added to
       an order that already exists. */
    function grab(tries) {
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).catch(function (err) {
        if (tries <= 0) throw err;
        return new Promise(function (ok) { setTimeout(ok, 2000); }).then(function () {
          return grab(tries - 1);
        });
      });
    }

    grab(1)
      .then(function (d) {
        var list = (d && d.products || []).filter(function (p) {
          /* never offer what they just bought */
          return String(p.variantId) !== String(variantEl && variantEl.value);
        });
        if (!list.length) return;
        list.forEach(function (p) { moreGrid.appendChild(moreCard(p, data, payload)); });
        moreWrap.hidden = false;
      })
      .catch(function () { /* no list is not a failure; the order stands */ });
  }

  function moreCard(p, data, payload) {
    var el = document.createElement('div');
    el.className = 'bh-more__item';
    var img = p.image
      ? '<img class="bh-more__img" src="' + p.image + '" alt="" width="80" height="80" loading="lazy">'
      : '<span class="bh-more__img"></span>';
    el.innerHTML = img
      + '<span class="bh-more__t"></span>'
      + '<span class="bh-more__p">' + money(p.price) + '</span>'
      + '<button type="button" class="bh-more__add"></button>';
    el.querySelector('.bh-more__t').textContent = p.title;
    /* Tap the photo to see the product properly.

       A swipe gallery inside the card itself was the obvious idea and the
       wrong one: the cards are 170px wide on a phone, and a horizontal
       swipe that narrow, nested inside the page's own vertical scroll, is
       something a thumb finds by accident rather than on purpose. Full
       screen has neither problem — it is its own surface, so the swipe has
       nowhere to conflict, and it is the gesture people already use for
       photos everywhere else.

       Nothing is loaded until it is opened. */
    var shots = (p.shots || []).filter(Boolean);
    var thumb = el.querySelector('.bh-more__img');
    if (shots.length && thumb && thumb.tagName === 'IMG') {
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      thumb.addEventListener('click', function () { openShots(shots, p.title); });
      thumb.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); openShots(shots, p.title); }
      });
    }

    var btn = el.querySelector('.bh-more__add');
    btn.textContent = root.dataset.moreAdd || 'Dodaj';

    /* One variant: one tap, straight in. Several: ask.

       These used to be left out of the list entirely, on the reasoning that
       a one-tap add cannot ask which size somebody wants — which quietly
       removed the knee brace and everything else sold in sizes, several of
       them the shop's best. Guessing is worse than asking: a brace sent in
       the wrong size comes straight back at the shop's expense, and on cash
       on delivery it is refused at the door and the whole parcel returns.

       So the button opens the sizes in place. Still no navigation, still
       inside the confirmation, one extra tap for the products that need
       one. */
    var choices = (p.variants || []).filter(function (x) { return x && x.id; });
    if (choices.length > 1) {
      var pick = document.createElement('div');
      pick.className = 'bh-more__pick';
      pick.hidden = true;
      choices.forEach(function (c) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'bh-more__chip';
        chip.textContent = c.title;
        chip.addEventListener('click', function () {
          addMore({ variantId: c.id, title: p.title + ' — ' + c.title }, el, btn, data, payload);
        });
        pick.appendChild(chip);
      });
      el.insertBefore(pick, btn);
      btn.addEventListener('click', function () {
        if (el.getAttribute('data-added')) return;
        pick.hidden = !pick.hidden;
        btn.textContent = pick.hidden
          ? (root.dataset.moreAdd || 'Dodaj')
          : (root.dataset.morePick || 'Izaberite:');
      });
      return el;
    }

    btn.addEventListener('click', function () { addMore(p, el, btn, data, payload); });
    return el;
  }


  /* The full-screen photo viewer. One element, reused, built the first time
     it is needed. Swiping is the browser's own scroll with snap points
     rather than a gesture library — it is smoother than anything hand
     written, and it keeps this file the only script the theme ships. */
  var shotBox = null;
  function openShots(list, title) {
    if (!shotBox) {
      shotBox = document.createElement('div');
      shotBox.className = 'bh-shots';
      shotBox.setAttribute('role', 'dialog');
      shotBox.setAttribute('aria-modal', 'true');
      shotBox.innerHTML =
        '<button type="button" class="bh-shots__x" aria-label="Zatvori">&times;</button>'
        + '<div class="bh-shots__strip"></div>'
        + '<p class="bh-shots__t"></p>';
      shotBox.addEventListener('click', function (ev) {
        if (ev.target === shotBox || ev.target.classList.contains('bh-shots__x')) closeShots();
      });
      document.body.appendChild(shotBox);
    }
    var strip = shotBox.querySelector('.bh-shots__strip');
    strip.innerHTML = '';
    list.forEach(function (src) {
      var im = document.createElement('img');
      im.src = src;
      im.alt = '';
      im.loading = 'lazy';
      strip.appendChild(im);
    });
    strip.scrollLeft = 0;
    shotBox.querySelector('.bh-shots__t').textContent = title || '';
    shotBox.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onShotKey);
  }

  function closeShots() {
    if (!shotBox) return;
    shotBox.removeAttribute('data-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onShotKey);
  }

  function onShotKey(ev) { if (ev.key === 'Escape') closeShots(); }

  function addMore(p, el, btn, data, payload) {
    /* One at a time. Two order edits racing each other on the same order is
       how a line goes missing, and the customer would have no way to know
       which of their taps counted. */
    if (moreBusy || btn.disabled) return;
    moreBusy = true;
    btn.disabled = true;
    var was = btn.textContent;
    btn.textContent = root.dataset.sendingLabel || '…';
    moreSay('');

    var give = setTimeout(function () { moreFail(btn, was, null); }, 12000);

    fetch(ENDPOINT.replace(/\/+$/, '') + '/upsell', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        orderId: orderRef.id, token: orderRef.token,
        variantId: p.variantId, discountPct: 0, quantity: 1
      })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (r.ok) return d;
          var e = new Error('HTTP ' + r.status); e.code = d && d.error; throw e;
        });
      })
      .then(function (res) {
        clearTimeout(give);
        moreBusy = false;
        /* the worker returns the order's NEW total, so the line the customer
           reads is the figure the courier will actually ask for */
        if (res && res.totalCents != null) {
          runTotal = res.totalCents;
          set('total', money(runTotal));
        }
        var cell = paneDone.querySelector('[data-bh-recap="product"]');
        if (cell) {
          var li = document.createElement('span');
          li.className = 'bh-recap__add';
          li.textContent = '+ ' + p.title;
          cell.appendChild(li);
        }
        el.setAttribute('data-added', 'true');
        var pickEl = el.querySelector('.bh-more__pick');
        if (pickEl) pickEl.hidden = true;
        btn.disabled = true;
        btn.textContent = root.dataset.moreAdded || '✓';
      })
      .catch(function (err) {
        clearTimeout(give);
        moreFail(btn, was, err);
      });
  }

  /* Nothing was added, so nothing is claimed. The recap and the total are
     left exactly as they were — on cash on delivery a receipt promising an
     item the driver is not carrying starts an argument at the door. */
  function moreFail(btn, was, err) {
    moreBusy = false;
    btn.disabled = false;
    btn.textContent = was;
    var gone = err && (err.code === 'expired' || err.code === 'token');
    moreSay(gone
      ? (root.dataset.moreExpired || 'Vrijeme za dodavanje je isteklo. Nazovite nas i dodaćemo.')
      : (root.dataset.moreFailed || 'Nije dodano. Pokušajte ponovo ili nas nazovite.'));
  }

  function showConfirmation(data, payload) {
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}

    stopTimer();
    offerMode(false);
    offers.forEach(function (o) { o.hidden = true; });

    /* The order is placed, so the page stops being a shop window. Price,
       stock, "order by phone", the guarantees and everything after the form
       all describe a decision that has already been made — leaving them up
       reads as though nothing happened, and the phone button invites a
       second order for the same thing. One attribute, so the rule lives in
       CSS next to the layout it undoes. */
    document.body.setAttribute('data-bh-ordered', '');

    set('order',   data.orderNumber || data.name || '#—');
    var bought = boughtName();
    var productCell = paneDone.querySelector('[data-bh-recap="product"]');
    if (productCell) {
      productCell.textContent = bought;
      /* each accepted offer on its own line, so the recap adds up to the
         figure printed under it */
      accepted.forEach(function (name) {
        var li = document.createElement('span');
        li.className = 'bh-recap__add';
        li.textContent = '+ ' + name;
        productCell.appendChild(li);
      });
    }
    set('address', payload.address + ', ' + payload.city);
    /* runTotal, not the figure the order came back with: after an accepted
       offer the courier collects more than the first total, and this line is
       what the customer reads as the amount to have ready. */
    set('total',   money(runTotal || (data.totalCents != null ? data.totalCents : payableCents())));

    /* The same basket, from the same number, to the same address, inside
       ten minutes. Shopify has one order and only one, and the customer is
       looking at it — but without a word they would reasonably read this
       screen as a second order and expect two parcels. */
    var dupe = paneDone.querySelector('[data-bh-dupe]');
    if (dupe) {
      if (data && data.deduped) {
        var mins = data.agoMin;
        var dtxt = dupe.querySelector('[data-bh-dupe-text]');
        if (dtxt) {
          /* Two facts before the question: what already exists, and that a
             second order does not. Somebody who tapped twice by accident
             needs both of those and nothing more. */
          dtxt.textContent = (mins
            ? (root.dataset.dupeLabel || 'Već ste naručili ovaj proizvod prije {min} min. Druga narudžba nije napravljena.').replace('{min}', mins)
            : (root.dataset.dupeNowLabel || 'Ovaj proizvod ste upravo naručili. Druga narudžba nije napravljena.'));
        }
        /* Somebody sending the same basket twice is usually somebody who
           thinks the first attempt failed — but not always. Some of them
           want two. Refusing both readings leaves the second sort with
           nothing to do but order again from scratch and pay a second
           delivery.

           So it is asked, not assumed, and the question names the number
           that would end up on the order. Nothing happens without the tap;
           down the same order-edit path the list below uses, so it stays
           one parcel and one delivery fee, and the recap and total move to
           the figure the driver will actually collect. */
        var dask = dupe.querySelector('[data-bh-dupe-ask]');
        var dbtn = dupe.querySelector('[data-bh-dupe-add]');
        /* orderRef: the worker only hands the token back to the same
           person (same name and address). Without it the add would fail,
           so the question is not asked. */
        if (dbtn && payload.variantId && orderRef) {
          if (dask) dask.hidden = false;
          dbtn.hidden = false;
          dbtn.addEventListener('click', function () {
            addMore({ variantId: payload.variantId, title: PRODUCT },
                    dupe, dbtn, data, payload);
          });
        } else if (dbtn) {
          dbtn.hidden = true;
          if (dask) dask.hidden = true;
        }
        dupe.hidden = false;
      } else {
        dupe.hidden = true;
      }
    }

    /* Shopify would not take the number, so the order was saved without
       one. On cash on delivery the courier's first act is a phone call, so
       this order cannot be delivered as it stands — and these few seconds
       are the last ones the only person who can fix it is still here. */
    var bad = paneDone.querySelector('[data-bh-badphone]');
    if (bad) {
      if (data && data.phoneUnverified && orderRef) {
        var badIn  = bad.querySelector('[data-bh-badphone-input]');
        var badBtn = bad.querySelector('[data-bh-badphone-save]');
        var badMsg = bad.querySelector('[data-bh-badphone-msg]');
        if (badIn) badIn.value = payload.phone || '';
        bad.hidden = false;
        /* "Zabilježili smo broj X" over a number that was just refused reads
           as all being well. Say what is actually true. */
        var sub = paneDone.querySelector('[data-bh-confirm-sub]');
        if (sub && root.dataset.confirmedBadphoneLabel) sub.textContent = root.dataset.confirmedBadphoneLabel;
        if (badBtn) {
          badBtn.addEventListener('click', function () {
            var v = badIn ? badIn.value : '';
            var d = v.replace(/\D/g, '').replace(/^00/, '').replace(/^387/, '').replace(/^0/, '');
            if (!(d.length >= 8 && d.length <= 12)) {
              if (badMsg) badMsg.textContent = root.dataset.errPhoneLabel || '';
              if (badIn) badIn.focus();
              return;
            }
            var was = badBtn.textContent;
            badBtn.disabled = true;
            badBtn.textContent = root.dataset.sendingLabel || '…';
            if (badMsg) badMsg.textContent = '';
            fetch(ENDPOINT.replace(/\/+$/, '') + '/phone', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              keepalive: true,
              body: JSON.stringify({ orderId: orderRef.id, token: orderRef.token, phone: v })
            })
              .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
              .then(function () {
                if (badIn) badIn.disabled = true;
                badBtn.textContent = root.dataset.moreAdded || '✓';
                if (badMsg) badMsg.textContent = root.dataset.badphoneOkLabel || '';
              })
              .catch(function () {
                badBtn.disabled = false;
                badBtn.textContent = was;
                /* Never a tick over a number that still cannot be rung. */
                if (badMsg) badMsg.textContent = root.dataset.badphoneFailLabel || '';
              });
          });
        }
      } else {
        bad.hidden = true;
      }
    }

    var subs = paneDone.querySelectorAll('[data-bh-phone]');
    Array.prototype.forEach.call(subs, function (n) { n.textContent = payload.phone; });

    paneForm.hidden = true;
    paneDone.hidden = false;

    /* The order exists and stays open for half an hour, so this is the one
       moment where "anything else?" costs the customer nothing: same
       parcel, same delivery fee, and the deciding is already done. */
    openMore(data, payload);

    var stickyBar = document.querySelector('[data-bh-sticky]');
    if (stickyBar) stickyBar.setAttribute('data-visible', 'false');

    var y = paneDone.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo(0, y < 0 ? 0 : y);

    /* Not for a repeat: the worker answered with the order that already
       existed, and counting it again doubles the sale in every report. */
    if (window.dataLayer && !(data && data.deduped)) {
      window.dataLayer.push({
        event: 'purchase',
        transaction_id: data.orderNumber,
        /* the total after any accepted offer, not the one the form started with */
        value: (runTotal || payableCents()) / 100,
        currency: root.dataset.currency || 'BAM'
      });
    }
  }

  function set(key, value) {
    var n = paneDone.querySelector('[data-bh-recap="' + key + '"]');
    if (n) n.textContent = value;
  }

  /* ---------- previewing an offer -------------------------
     An offer is normally unreachable without placing a real order, which
     is a poor way to check whether the wording fits. Two ways in, and
     neither creates or touches anything:

       ?bh_offer=1        the first offer, on the real page, on a phone
       theme editor       select an offer block and it appears

     Buttons only cycle here — accept posts nothing. */
  function previewOffer(i) {
    if (!offers.length) return;
    var el = offers[Math.min(Math.max(i, 0), offers.length - 1)];
    stopTimer();
    offerMode(true);
    paneForm.hidden = true;
    paneDone.hidden = true;
    offers.forEach(function (o) { o.hidden = true; });
    el.hidden = false;

    var stop = function () {
      stopTimer();
      offerMode(false);
      el.hidden = true;
      paneForm.hidden = false;
    };
    var no = el.querySelector('[data-bh-offer-no]');
    var yes = el.querySelector('[data-bh-offer-yes]');
    if (no) no.onclick = stop;
    if (yes) yes.onclick = stop;
    startTimer(el, stop);

    var y = el.getBoundingClientRect().top + window.pageYOffset - 8;
    window.scrollTo(0, y < 0 ? 0 : y);
  }

  var wanted = new URLSearchParams(location.search).get('bh_offer');
  if (wanted) previewOffer(parseInt(wanted, 10) - 1);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (e) {
      var i = offers.indexOf(e.target);
      if (i >= 0) previewOffer(i);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (offers.indexOf(e.target) < 0) return;
      stopTimer();
      offerMode(false);
      e.target.hidden = true;
      paneForm.hidden = false;
    });
  }

  /* ---------- "šaljemo danas" ----------------------------- */
  /* Liquid works this out when Shopify renders the page, and Shopify can
     hand out a cached copy — so "šaljemo danas" could still be showing at
     23h. The same rule again here, on the clock in Sarajevo. */
  (function () {
    var el = document.querySelector('[data-bh-dispatch]');
    if (!el || !window.Intl) return;
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Sarajevo', hour: 'numeric', hourCycle: 'h23', weekday: 'short'
      }).formatToParts(new Date());
      var hour = 0, wd = '';
      parts.forEach(function (p) {
        if (p.type === 'hour') hour = parseInt(p.value, 10);
        if (p.type === 'weekday') wd = p.value;
      });
      var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(wd);
      if (day < 0) return;
      var cutoff = parseInt(el.dataset.cutoff, 10) || 15;
      var sat = el.dataset.sat === '1';
      var when = 'today';
      if (day === 0) when = 'monday';
      else if (day === 6) when = (sat && hour < cutoff) ? 'today' : 'monday';
      else if (hour >= cutoff) when = day === 5 ? (sat ? 'tomorrow' : 'monday') : 'tomorrow';
      var text = el.dataset[when];
      if (text) el.textContent = text;
    } catch (e) { /* keep what Liquid printed */ }
  })();

  /* ---------- sticky bar ---------------------------------- */
  var sticky = document.querySelector('[data-bh-sticky]');
  if (sticky) {
    var ticking = false;
    var paint = function () {
      var box = form.getBoundingClientRect();
      /* Hide the bar while the form itself is on screen —
         two identical CTAs at once is the classic COD mistake. */
      var formVisible = box.top < window.innerHeight && box.bottom > 0;
      /* From the first screen, not after 320px of scroll: on a phone the
         first screen is the photo, and it had no order button at all —
         the one moment an ad visitor decides whether to stay. */
      var pastHero = true;
      var done = paneDone && !paneDone.hidden;
      /* An offer owns the screen while it is up: the form is hidden, so
         formVisible reads false and the bar would otherwise reappear over
         an offer whose whole point is to fit above the fold. */
      var offering = offers.some(function (o) { return !o.hidden; });
      sticky.setAttribute('data-visible', (pastHero && !formVisible && !done && !offering) ? 'true' : 'false');
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(paint);
    }, { passive: true });
    paint();

    /* If the tab is backgrounded mid-scroll the pending animation frame
       never runs, `ticking` stays true and the bar freezes. Repaint and
       clear the latch whenever the page becomes visible again. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      ticking = false;
      paint();
    });
    window.addEventListener('pageshow', function () {
      ticking = false;
      paint();
    });

    /* The sticky button NEVER submits. It scrolls to the form
       and focuses the first field. */
    var jump = sticky.querySelector('[data-bh-jump]');
    if (jump) {
      jump.addEventListener('click', function () {
        var y = form.getBoundingClientRect().top + window.pageYOffset - 70;
        window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
        setTimeout(function () { var i = inputOf('name'); if (i) i.focus(); }, 380);
      });
    }
  }
})();
